export const UPGRADE_PROMPT_MODAL_18151_KEY = 'sf_18151_upgrade_prompt_modal'
export const PAGES_VISITED_18151_KEY = 'sf_18151_pages_visited'
export const ANNUAL_UPSELL_PROMPT_PAGES_VISITED_18236_KEY =
  'sf_18236_annual_upsell_prompt_pages_visited'
export const ANNUAL_UPSELL_PROMPT_MODAL_18236_KEY =
  'sf_18236_annual_upsell_prompt_modal'
export const ANNUAL_UPSELL_PROMPT_BANNER_18236_KEY =
  'sf_18236_annual_upsell_prompt_banner'

export const PARTNER_CREATOR_SESSION_KEY = 'sf_partner_creator'
export const BANNER_DISMISSED_KEY = 'sf_partner_discount_banner_dismissed'
export const POPUP_DISMISSED_KEY = 'sf_partner_discount_popup_dismissed'
